import React from 'react';
import xtend from 'xtend';
import moment from 'moment';
import _ from 'underscore'
import Model from '@nichoth/observ/model'
import struct from '@nichoth/observ/struct'
import observ from '@nichoth/observ/observ'

import { createRequestFn } from '../analytics/util'
// import { ReadOnlyModel } from '../models'
import View from '../admin/components/AdminView'
import Timer from '../admin/AnalyticsTimer.js';

const adminRoute = (api, socket, opts) => {
    var liveTimer = new Timer(getLiveStats);
    let timerActive = true
    var request = createRequestFn({ clientID: opts.credentials.clientID })

    var io = {
        getMostWatched: request('/stats/getMostWatched'),
        getViewerCounts: request('/stats/landingStats'),
        // getDataConsumption: request('/stats/getDataConsumption'),
        // getBillingUsageMTD: request('/stats/getBillingUsageMTD'),
        getUpcomingEvents: api.events.get
    }
    var models = createModels({ io })
    var modelState = Object.keys(models).reduce(function (acc, k) {
        acc[k] = Model.getState(models[k])
        return acc
    }, {})
    var state = struct(modelState)

    var query = {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD')
    }

    function getLiveStats () {
        if (timerActive) {
            models.viewerCounts.get({
                showCurrent: true,
                // startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                // stopDate: moment().format('YYYY-MM-DD')
            }, function (err, res) {
                liveTimer.restart()
            })
        }
    }

    function fetchEverything () {
        models.mostWatchedEvents.get(query)
        // models.billing.get({})
        getLiveStats()
        // models.bandwidthUsage.get(query)
        models.upcomingEvents.get({
            startDateTime: moment().format('YYYY-MM-DD'),
            stopDateTime: moment().add(7, 'days').format('YYYY-MM-DD'),
            sortBy: 'ASC'
        })
    }

    function doUnmountTimer () {
        liveTimer.stop();
        timerActive = false
    }

    class AdminHomeView extends React.Component {
        constructor (props) {
            super(props)
            this.state = state()
        }

        componentDidMount () {
            timerActive = true
            var self = this
            this._unlisten = state(function onChange (_state) {
                self.setState(_state)
            })
            fetchEverything()
        }

        componentWillUnmount () {
            doUnmountTimer()
            this._unlisten()
        }

        render () {
            return <div id="analytics-landing">
                <View {...this.state } 
                client={opts.credentials.client}
                />
            </div>
        }
    }

    return AdminHomeView
}

function createModels ({ io }) {
    return {
        mostWatchedEvents: Model({
            io: { get: io.getMostWatched },
            state: { data: observ([]) },
            update: {
                get: (state, res) => {
                    state.hasFetched.set(true)
                    state.data.set(_.sortBy(res.result, 'plays').reverse())
                }
            }
        }),

        // keep the last 10 responses for the graph
        viewerCounts: Model({
            io: { get: io.getViewerCounts },
            state: {
                data: observ([])
            },
            update: {
                get: function (state, res) {
                    if (!state().hasFetched) state.hasFetched.set(true)

                    var newData = xtend(res.result, {
                        time: moment().format('HH:mm:ss')
                    })

                    var update = [].concat(state.data())
                    if (update.length >= 10) update.pop()
                    update.unshift(newData)
                    state.data.set(update)
                }
            }
        }),

        // bandwidthUsage: ReadOnlyModel({
        //     io: { get: io.getDataConsumption }
        // }),

        // billing: ReadOnlyModel({
        //     io: { get: io.getBillingUsageMTD }
        // }),

        upcomingEvents: Model({
            io: { get: io.getUpcomingEvents },
            state: {
                data: observ([])
            },
            update: {
                get: function (state, res) {
                    state.hasFetched.set(true)
                    state.data.set(res.data)
                }
            }
        })
    }
}

export default adminRoute
